module.exports = "https://web-assets-production.autolist.com/_next/static/images/search-on-the-go-8c9f0a9474591e37dbc8707199947a1c.jpg";